import { AnyInformationResponse, CoreType } from '@/api-client/models/shared/Contracts'
import { useDataFetcher } from '@/composables/useDataFetcher'
import { FetchType } from '@/fetches'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type Information = {
  numberOf: Partial<Record<CoreType, number>>
  optionsWithData: Record<string, string[]>
}

export const useInformation = defineStore('information', () => {
  const fetchId = ref<FetchType | undefined>(undefined)

  const submittedData = useDataFetcher<FetchType, AnyInformationResponse>(fetchId)
  const currentData = useDataFetcher<FetchType, AnyInformationResponse>(fetchId, {
    useSubmittedFilter: false
  })

  const submitted = computed(() => ({
    data: submittedData.data.value,
    isLoading: submittedData.isLoading.value,
    error: submittedData.error.value
  }))

  const current = computed(() => ({
    data: currentData.data.value,
    isLoading: currentData.isLoading.value,
    error: currentData.error.value
  }))

  function setFetchId(value: FetchType) {
    fetchId.value = value
  }

  async function fetch() {
    submittedData.fetch()
    currentData.fetch()
  }

  return {
    setFetchId,
    fetch,
    current,
    submitted
  }
})
